import React from 'react';
import 'sweetalert2/dist/sweetalert2.css';

import { Ai2Layout } from '../../layout/Ai2Layout';
import {
  UserInfo,
  PinOptionSelector,
  CurrentPinForm,
  ForgotPinForm,
} from './components';
import MyAccountProvider from './context/MyAccountContext';

const MyAccount: React.FC = () => {
  return (
    <MyAccountProvider>
      <Ai2Layout>
        <div
          style={{
            overflow: 'auto',
            maxHeight: 'calc(100vh - 70px)',
            marginTop: '70px',
          }}
        >
          <div className="bgHeading ">
            <h1 className="heading1">My Account</h1>
          </div>

          <div className="ui container-fluid">
            <div className="spContainer">
              <UserInfo />
              <hr />
              <h4 className="heading2">Change PIN</h4>
              <PinOptionSelector />
              <CurrentPinForm />
              <ForgotPinForm />
            </div>
          </div>
        </div>
      </Ai2Layout>
    </MyAccountProvider>
  );
};

export { MyAccount };
